module.exports = __webpack_public_path__ + "img/1465603803.3b7a89ba.jpg";